import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';

import * as schemas from 'store/common/schemas';
import * as entitySelectors from 'store/entities/selectors';

export const selectCompanyTeamMemberConnectionById = createSelector(
  entitySelectors.selectAllEntities,
  (state, props) => props.id,
  (entities, id) => denormalize(id, schemas.companyTeamMemberConnection, entities)
);



// WEBPACK FOOTER //
// ./src/store/features/company-team-member-connections/selectors.js